<template>
  <div class="modal-overlay">
    <div class="card" @click.stop>
      <div class="card-header">
        <i class="fa fa-category-o text-primary me-2" />New Category
      </div>
      <hr class="horizontal dark m-0" />

      <el-form
        ref="categoryFormRef"
        :model="categoryForm"
        :rules="rules"
        label-width="120px"
        size=""
        status-icon
        :scroll-to-error="true"
        label-position="top"
        :hide-required-asterisk="true"
      >
        <div class="card-body">
          <div class="mb-3">
            <el-form-item label="Category Name" prop="name">
              <el-input v-model="categoryForm.name" />
            </el-form-item>
          </div>

          <div class="mb-3">
            <el-form-item label="Description" prop="description">
              <el-input v-model="categoryForm.description" type="textarea" />
            </el-form-item>
          </div>

          <div class="mb-3">
            <el-form-item label="Parent Category" prop="parent category">
              <el-tree-select
                v-model="categoryForm.parent_id"
                :render-after-expand="false"
                :data="categoryTree"
                placeholder="Please select a category"
                style="width: 100%"
                check-strictly
              />
            </el-form-item>
          </div>
        </div>
        <div class="card--footer">
          <button
            class="btn mb-0 btn-danger btn-xs"
            @click="$emit('close-modal')"
          >
            Cancel
          </button>
          <el-button
            type="success"
            :loading="isLoading"
            @click="submitForm(categoryFormRef)"
            >Submit</el-button
          >
        </div>
      </el-form>
    </div>
    <div class="close bg-danger" @click="$emit('close-modal')">
      <i class="fa fa-times" />
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import {
  createCategory,
  updateCategory,
  fetchCategoriesTree,
} from "../../api/services/inventory";
import { ElNotification } from "element-plus";
const categoryFormRef = ref();
const isLoading = ref(false);
const categoryTree = ref([]);
export default {
  name: "add-category",
  props: {
    category: {
      type: Object,
      required: false,
    },
  },
  setup(props, { emit }) {
    const categoryForm = reactive({
      id: props?.category?.id || 0,
      name: props?.category?.name || "",
      description: props?.category?.description || "",
      parent_id: props?.category?.parent_id || null,
    });

    const rules = reactive({
      name: [
        {
          required: true,
          message: "Please input category name",
          trigger: ["blur", "change"],
        },
      ],
      description: [
        {
          required: true,
          message: "Please input a description",
          trigger: ["blur", "change"],
        },
      ],
    });

    const submitForm = async (formEl) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          isLoading.value = true;
          const formData = new FormData();

          formData.append("name", categoryForm.name);
          formData.append("description", categoryForm.description);
          formData.append("parent_id", categoryForm.parent_id ?? 0);
          if (categoryForm.id > 0) {
            updateCategory(categoryForm)
              .then((data) => {
                if (data.success) {
                  ElNotification({
                    title: "Success",
                    message: data.message,
                    type: "success",
                  });
                  emit("refresh-categories");
                  emit("close-modal");
                } else {
                  Object.values(data.errors).forEach((val) =>
                    ElNotification({
                      title: "Error",
                      message: val[0],
                      type: "error",
                    })
                  );
                }
              })
              .catch((err) =>
                ElNotification({
                  title: "Error",
                  message: err.message,
                  type: "error",
                })
              )
              .finally(() => {
                isLoading.value = false;
              });
          } else {
            createCategory(formData)
              .then((data) => {
                if (data.success) {
                  ElNotification({
                    title: "Success",
                    message: data.message,
                    type: "success",
                  });
                  emit("refresh-categories");
                  emit("close-modal");
                } else {
                  Object.values(data.errors).forEach((val) =>
                    ElNotification({
                      title: "Error",
                      message: val[0],
                      type: "error",
                    })
                  );
                }
              })
              .catch((err) =>
                ElNotification({
                  title: "Error",
                  message: err.message,
                  type: "error",
                })
              )
              .finally(() => {
                isLoading.value = false;
              });
          }
        } else {
          console.log("error submit!", fields);
        }
      });
    };
    const fetchAttributes = async () => {
      isLoading.value = true;
      try {
        const response = await fetchCategoriesTree();
        categoryTree.value = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        isLoading.value = false;
      }
    };
    return {
      submitForm,
      rules,
      categoryForm,
      categoryFormRef,
      isLoading,
      props,
      fetchAttributes,
      categoryTree,
    };
  },
  mounted() {
    this.fetchAttributes();
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}

.card {
  margin-top: 5%;
  outline: 0;
  border-radius: 7px;
  min-width: 500px;
  max-width: 900px;
  max-height: 700px;
  box-shadow: 0 10px 20px -8px rgba(0, 0, 0, 0.15);
}
.card-body {
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}

.card-header {
  border-bottom: 1px solid #e9ecef;
  padding: 1.2rem !important;
}
.card--footer {
  display: flex;
  justify-content: space-between;
  padding: 0 1.2rem 1.2rem 1.2rem !important;
}
.close {
  margin: 5% 0 0 10px;
  cursor: pointer;
  color: #fff;
  border: 2px solid #fff;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
}

input {
  border-radius: 6px;
}
</style>
